const actions = {
    save({commit},payload) {
        commit('setComparison',payload)
    },
    reset({commit}) {
        commit('resetComparison')
    },
    setChangeStatus({commit}, payload) {
        commit('setChangeStatus', payload)
    },
    setIsComparisonStatus({commit}, payload) {
        commit('setIsComparisonStatus', payload)
    }
};

export default actions;